export async function refreshPositionsHistoryAssignmentsIfActive(selectedTab, assignmentView) {
  if (selectedTab !== "positionshistory") return;
  if (assignmentView && typeof assignmentView.refreshAssignmentList === "function") {
    await assignmentView.refreshAssignmentList();
  }
}
